import React from 'react';
import { Link } from 'react-router';
import '../styles/ProductCard.css';

const ProductCard = ({ product }) => {
    return (
        <div className="product-card">
            <div className="product-image-container">

                {/* Status Ribbon */}
                {product.status && (
                    <div className={`ribbon ${product.status.toLowerCase()}`}>
                        {product.status.toLowerCase()}
                    </div>
                )}
                <Link to={`/property/${product.id}`} className="product-card-link">
                <img
                    src={product.imageUrl1}
                    alt={product.title}
                    className="product-image"
                />
                </Link>
            </div>

            <div className="product-details">
                <h3 className="product-title">{product.title}</h3>
                <p className="product-description">{product.description}</p>

                <div className="product-specs">
                    <div className="spec-item">
                        <span className="spec-label">Discounted Price:</span>
                        <span className="spec-value">{product.price}</span>
                    </div>
                    <div className="spec-item">
                        <span className="spec-label">Size:</span>
                        <span className="spec-value">{product.size}</span>
                    </div>
                    <div className="spec-item">
                        <span className="spec-label">Location:</span>
                        <span className="spec-value">{product.location}</span>
                    </div>
                </div>

                <div className="cta-buttons">
                 <Link to={`/property/${product.id}`} className='link-buttons' >
                    <button className="cta-button primary">MORE DETAILS</button>

                 </Link>
                </div>
            </div>
        </div>
    );
};

export default ProductCard; 